import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import NavCard from '@src/components/NavCard';
import SwipeSlider from '@src/components/SwipeSlider';

import css from './style.module.scss';

const Suggestions = ({
	events,
	src,
	forceVisibility,
	title,
	mix,
	adaptive,
	sliderTrackMix,
	sliderWrapMix,
	NavCardRP,
}) => {
	return (
		<div
			className={cn(css.block, mix, {
				[css[`block_adapt_${adaptive}`]]: !!adaptive,
			})}
		>
			<SwipeSlider
				title={title}
				isInnerArrows={false}
				swipeQtty="auto"
				headMix={css.head}
				wrapMix={cn(css.sliderWrap, sliderWrapMix)}
				trackMix={cn(css.sliderTrack, sliderTrackMix)}
				titleMix={css.sliderTitle}
				slideMix={css.slide}
			>
				{events.map((event) => (
					<NavCardRP
						key={event.title}
						{...event}
						src={event.src || src}
						forceVisibility={forceVisibility}
					/>
				))}
			</SwipeSlider>
		</div>
	);
};

Suggestions.propTypes = {
	/**
	 * Массив-объектов, описывающих навигационную карточку. Где:<br>
	 * - **title** — заголовок карточки;<br>
	 * - **src** — путь к изображению карточки;<br>
	 * - **href** — ссылка карточки.
	 */
	events: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string,
			src: PropTypes.string,
			href: PropTypes.string,
			isShallow: PropTypes.bool,
		}),
	),
	/**
	 * URL-адрес изображения мероприятия.
	 */
	src: PropTypes.string,
	/**
	 * Ключ для форсирования видимости изображения
	 */
	forceVisibility: PropTypes.bool,
	/**
	 * Заголовок блока.
	 */
	title: PropTypes.string,
	mix: PropTypes.string,
	adaptive: PropTypes.oneOf(['default']),
	sliderTrackMix: PropTypes.string,
	sliderWrapMix: PropTypes.string,
	NavCardRP: PropTypes.elementType,
};

Suggestions.defaultProps = {
	events: [],
	src: 'img/null.svg',
	forceVisibility: false,
	title: t('Какое мероприятие планируете?'),
	mix: undefined,
	adaptive: undefined,
	sliderTrackMix: undefined,
	sliderWrapMix: undefined,
	NavCardRP: NavCard,
};

export default Suggestions;
